import { render, staticRenderFns } from "./WorkflowProcessFlow.vue?vue&type=template&id=648a3cb2&"
import script from "./WorkflowProcessFlow.vue?vue&type=script&lang=js&"
export * from "./WorkflowProcessFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports